export default function initClock() {
  const clockElements = document.querySelectorAll(".home__about-clock");

  if (!clockElements.length) return;

  clockElements.forEach(clockElement => {
    createClock(clockElement);
  });
}

function createClock(clockElement) {
  const timezone = clockElement.dataset.timezone || "Europe/Paris";

  const clockFace = document.createElement("div");
  clockFace.classList.add("clock");

  const hourHand = document.createElement("div");
  hourHand.classList.add("clock__hand", "clock__hand--hour");

  const minuteHand = document.createElement("div");
  minuteHand.classList.add("clock__hand", "clock__hand--minute");

  const secondHand = document.createElement("div");
  secondHand.classList.add("clock__hand", "clock__hand--second");

  for (let i = 1; i <= 12; i++) {
    const marker = document.createElement("div");
    marker.classList.add("clock__marker");
    marker.style.transform = `rotate(${i * 30}deg)`;
    clockFace.appendChild(marker);
  }

  clockFace.appendChild(hourHand);
  clockFace.appendChild(minuteHand);
  clockFace.appendChild(secondHand);
  clockElement.appendChild(clockFace);

  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone: timezone,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
    hour12: false,
  });

  function updateClock() {
    const parts = formatter.formatToParts(new Date());
    const hours = parseInt(parts.find(p => p.type === "hour").value, 10);
    const minutes = parseInt(parts.find(p => p.type === "minute").value, 10);
    const seconds = parseInt(parts.find(p => p.type === "second").value, 10);

    const hourAngle = (hours % 12) * 30 + minutes * 0.5;
    const minuteAngle = minutes * 6;
    const secondAngle = seconds * 6;

    hourHand.style.transform = `rotate(${hourAngle}deg)`;
    minuteHand.style.transform = `rotate(${minuteAngle}deg)`;
    secondHand.style.transform = `rotate(${secondAngle}deg)`;

    requestAnimationFrame(updateClock);
  }

  updateClock();
}
